import Model, { attr, belongsTo } from '@ember-data/model';
import { service } from '@ember/service';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { isPresent } from '@ember/utils';
import { rollbackBelongsTo, isBelongsToRefDirty } from 'eflex/util/relationship-helpers';
import { copyable, arrayAttr, caption } from 'eflex/decorators';

@copyable
@buildValidations({
  title: [
    validator('length', {
      min: 1,
      max: 10,
      allowBlank: false,
      get disabled() {
        return this.model.constructor.name === 'StationJemConfiguration';
      },
    }),
    validator('presence', {
      get disabled() {
        return this.model.constructor.name === 'StationJemConfiguration' || isPresent(this.model.model);
      },
      presence: true,
      ignoreBlank: true,
    }),
  ],
})
class JemConfiguration extends Model {
  @attr('string') externalImageUrl;
  @attr('number') page;
  @arrayAttr titleCaptions;
  @caption('titleCaptions') title;

  @belongsTo('model', {
    async: false,
    inverse: 'jemConfigurations',
    as: 'jem-configuration',
  }) model;

  @belongsTo('station', {
    async: false,
    inverse: 'jemConfigurations',
    as: 'jem-configuration',
  }) station;

  @belongsTo('work-instruction', {
    async: false,
    inverse: 'jemConfigurations',
    as: 'jem-configuration',
  }) workInstruction;

  @service workInstructionRepo;

  get polymorphic() {
    return true;
  }

  get isDirty() {
    return super.isDirty || isBelongsToRefDirty(this, 'workInstruction');
  }

  get hasExternalUrl() {
    return isPresent(this.externalImageUrl);
  }

  get modelId() {
    return this.model?.id;
  }

  get modelCode() {
    return this.model?.code;
  }

  get parent() {
    return this.station;
  }

  set parent(val) {
    this.station = val;
  }

  get configModel() {
    return this.model;
  }

  set configModel(val) {
    this.model = val;
  }

  get fullExternalUrl() {
    if (this.externalImageUrl == null) {
      return null;
    } else if (this.page == null) {
      return this.externalImageUrl;
    } else {
      return `${this.externalImageUrl}#page=${this.page}`;
    }
  }

  get copyableOptions() {
    return {
      ignoreAttributes: new Set(['station', 'taskConfig']),
      copyByReference: new Set(['workInstruction', 'model']),
    };
  }

  setExternalImageUrl(url, page) {
    this.workInstructionRepo.setExternalImageUrl(this, url, page);
  }

  setWorkInstruction(workInstruction) {
    this.workInstructionRepo.setWorkInstruction(this, workInstruction);
  }

  rollbackAttributes() {
    rollbackBelongsTo(this, 'workInstruction');
    super.rollbackAttributes();
  }
}

export default JemConfiguration;
